// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2UGRP","largestCol":"styles_largestCol__1W47X","smallestCol":"styles_smallestCol__1tTKr"};